type FirebaseNotificationEnv = Record<string, string | undefined>;

export interface FirebaseNotificationAppConfig {
  apiKey: string;
  authDomain: string;
  projectId: string;
  storageBucket: string;
  messagingSenderId: string;
  appId: string;
}

export interface FirebaseNotificationConfig {
  appConfig: FirebaseNotificationAppConfig;
  vapidKey: string;
  missingKeys: string[];
}

const FIREBASE_NOTIFICATION_ENV_MAP: Record<keyof FirebaseNotificationAppConfig | 'vapidKey', string> = {
  apiKey: 'VUE_APP_FIREBASE_API_KEY',
  authDomain: 'VUE_APP_FIREBASE_AUTH_DOMAIN',
  projectId: 'VUE_APP_FIREBASE_PROJECT_ID',
  storageBucket: 'VUE_APP_FIREBASE_STORAGE_BUCKET',
  messagingSenderId: 'VUE_APP_FIREBASE_MESSAGING_SENDER_ID',
  appId: 'VUE_APP_FIREBASE_APP_ID',
  vapidKey: 'VUE_APP_FIREBASE_VAPID_KEY',
};

const envValue = (env: FirebaseNotificationEnv, key: string): string => String(env[key] || '').trim();

export const firebaseNotificationConfig = (
  env: FirebaseNotificationEnv = process.env
): FirebaseNotificationConfig => {
  const appConfig = {
    apiKey: envValue(env, FIREBASE_NOTIFICATION_ENV_MAP.apiKey),
    authDomain: envValue(env, FIREBASE_NOTIFICATION_ENV_MAP.authDomain),
    projectId: envValue(env, FIREBASE_NOTIFICATION_ENV_MAP.projectId),
    storageBucket: envValue(env, FIREBASE_NOTIFICATION_ENV_MAP.storageBucket),
    messagingSenderId: envValue(env, FIREBASE_NOTIFICATION_ENV_MAP.messagingSenderId),
    appId: envValue(env, FIREBASE_NOTIFICATION_ENV_MAP.appId),
  };
  const vapidKey = envValue(env, FIREBASE_NOTIFICATION_ENV_MAP.vapidKey);
  const missingKeys = Object.entries(FIREBASE_NOTIFICATION_ENV_MAP)
    .filter(([configKey]) => {
      if (configKey === 'vapidKey') {
        return !vapidKey;
      }

      return !appConfig[configKey as keyof FirebaseNotificationAppConfig];
    })
    .map(([, envKey]) => envKey);

  return {
    appConfig,
    vapidKey,
    missingKeys,
  };
};

export const hasFirebaseNotificationConfig = (
  env: FirebaseNotificationEnv = process.env
): boolean => firebaseNotificationConfig(env).missingKeys.length === 0;
